var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-3 col-sm-12 col-12 col-md-6 col-lg-4, col-xl-3"},[_c('b-button',{staticClass:"w-100 p-3",attrs:{"pill":"","target":"_blank","href":_vm.destinationURL}},[_c('b-icon',{attrs:{"icon":_vm.iconComponent}}),_vm._v(" "+_vm._s(_vm.titleString))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }